<script setup>
import { ref } from "vue";

const showModal = ref(false);

import { useRoute, useRouter } from "vue-router";
import { useUserStore } from "../services/Store";
import Cookies from "js-cookie";

const userStore = useUserStore();
const route = useRoute();
const router = useRouter();

const pages = [
  { name: "Dashboard", path: "/dashboard" },
  { name: "Users", path: "/user" },
  { name: "Agents", path: "/agent" },
  { name: "Plans", path: "/plan" },
  { name: "Add-Ons", path: "/addons" },
  { name: "Website", path: "/website" },
  { name: "Subscriptions", path: "/subscriptions" },
  { name: "Publish Articles", path: "/publish-articles" },
  { name: "AI Usage", path: "/ai-usage" },
  { name: "Invoices", path: "/invoices" },
  { name: "Commissions", path: "/commissions" },
  { name: "Changelog", path: "/changelog" },
  { name: "Prospecting", path: "/prospecting" },
  { name: "Our Sites", path: "/our-sites" },
  { name: "Our Chatbot", path: "/our-chatbot" },
  { name: "Subscribers", path: "/subscribers" },
];

const logout = () => {
  userStore.clearUser();
  Cookies.remove("authToken", { path: "/" });
  window.location.href = "/";
  // Same fix as UserLayouts.vue's logout() — preserve tourSeen:* keys
  // (the client-side "has this user seen the onboarding tour" flag)
  // instead of blanket-clearing localStorage, so the tour doesn't replay
  // on every login for a user who also has admin access.
  Object.keys(localStorage)
    .filter((key) => !key.startsWith("tourSeen:"))
    .forEach((key) => localStorage.removeItem(key));
  sessionStorage.clear();
};
</script>

<template>
  <div class="flex flex-col min-h-[100dvh]">
<div class="flex justify-between items-center px-4 py-2 sticky top-0 z-50 bg-white shadow">
      <router-link to="/">
        <img src="/images/logo.svg" alt="Example Image" class="navLogo" />
      </router-link>
      <div class="flex gap-2">
        <!-- <div class="flex px-4 py-1.5 rounded-2xl bg-[#F9FAFB] max-w-md mx-auto">
          <svg
            width="24"
            height="23"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23.414 21.3868L18.337 16.3098C19.386 14.7288 20 12.8358 20 10.8008C20 5.28678 15.514 0.800781 10 0.800781C4.486 0.800781 0 5.28678 0 10.8008C0 16.3148 4.486 20.8008 10 20.8008C12.035 20.8008 13.928 20.1868 15.509 19.1378L20.586 24.2148C21.366 24.9958 22.634 24.9958 23.414 24.2148C24.195 23.4338 24.195 22.1678 23.414 21.3868ZM3 10.8008C3 6.94078 6.14 3.80078 10 3.80078C13.86 3.80078 17 6.94078 17 10.8008C17 14.6608 13.86 17.8008 10 17.8008C6.14 17.8008 3 14.6608 3 10.8008Z"
              fill="#40008A"
            />
          </svg>

          <input
            type="email"
            placeholder="Search here..."
            class="w-full outline-none bg-transparent text-gray-600 text-sm pl-1"
          />
        </div> -->
        <div class="relative">
          <div
            class="absolute size-1 rounded-full top-2 right-1.5 bg-red-600"
          ></div>
          <svg
            width="37"
            height="37"
            viewBox="0 0 37 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.910156"
              y="0.626953"
              width="35.2407"
              height="35.84"
              rx="8"
              fill="#FFFAF1"
            />
            <path
              d="M25.6327 23.4403C25.1607 23.0124 24.7475 22.5218 24.4042 21.9818C24.0293 21.2364 23.8047 20.4224 23.7434 19.5875V17.1285C23.7466 15.8171 23.2789 14.5497 22.4281 13.5644C21.5773 12.579 20.402 11.9436 19.123 11.7774V11.1352C19.123 10.959 19.0541 10.79 18.9316 10.6653C18.809 10.5407 18.6428 10.4707 18.4695 10.4707C18.2962 10.4707 18.13 10.5407 18.0075 10.6653C17.885 10.79 17.8161 10.959 17.8161 11.1352V11.7873C16.5486 11.9655 15.3874 12.6048 14.5478 13.5868C13.7082 14.5689 13.2469 15.8271 13.2495 17.1285V19.5875C13.1882 20.4224 12.9636 21.2364 12.5887 21.9818C12.2515 22.5206 11.8449 23.0111 11.3798 23.4403C11.3276 23.4869 11.2857 23.5444 11.257 23.6087C11.2284 23.6731 11.2135 23.743 11.2134 23.8136V24.4906C11.2134 24.6226 11.2649 24.7492 11.3567 24.8426C11.4485 24.9359 11.573 24.9884 11.7028 24.9884H25.3096C25.4395 24.9884 25.564 24.9359 25.6557 24.8426C25.7475 24.7492 25.7991 24.6226 25.7991 24.4906V23.8136C25.799 23.743 25.7841 23.6731 25.7554 23.6087C25.7267 23.5444 25.6849 23.4869 25.6327 23.4403ZM12.2314 23.9928C12.6868 23.5454 13.0878 23.0441 13.4257 22.4995C13.8978 21.5993 14.1733 20.606 14.2333 19.5875V17.1285C14.2139 16.5451 14.3101 15.9637 14.5162 15.4189C14.7224 14.8742 15.0342 14.3772 15.4331 13.9575C15.832 13.5378 16.3099 13.2041 16.8383 12.9762C17.3667 12.7482 17.9347 12.6308 18.5087 12.6308C19.0826 12.6308 19.6507 12.7482 20.1791 12.9762C20.7075 13.2041 21.1854 13.5378 21.5843 13.9575C21.9832 14.3772 22.295 14.8742 22.5011 15.4189C22.7073 15.9637 22.8035 16.5451 22.7841 17.1285V19.5875C22.8441 20.606 23.1195 21.5993 23.5917 22.4995C23.9296 23.0441 24.3305 23.5454 24.7859 23.9928H12.2314Z"
              fill="#40008A"
            />
            <path
              d="M18.5305 26.6506C18.8388 26.6433 19.1347 26.5255 19.3658 26.3178C19.5969 26.1101 19.7483 25.8259 19.7933 25.5156H17.2188C17.265 25.8344 17.4235 26.1252 17.6648 26.3339C17.9061 26.5427 18.2137 26.6552 18.5305 26.6506Z"
              fill="#40008A"
            />
          </svg>
        </div>

        <div class="flex flex-wrap items-center justify-between">
          <div class="relative">
            <button
              class="flex items-center whitespace-nowrap cursor-pointer"
              @click="showModal = !showModal"
              type="button"
            >
              <img
                :src="
                  userStore?.user?.avatar ||
                  'https://tecdn.b-cdn.net/img/Photos/Avatars/img (31).webp'
                "
                class="rounded-full border-2 border-[#40008A]/30 object-cover flex-shrink-0"
                style="height: 36px; width: 36px"
                alt="Avatar"
                loading="lazy"
              />
              <div class="px-2 flex flex-col min-w-0" style="max-width: 140px;">
                <p
                  class="text-[12px] truncate font-[600] text-gray-800"
                  :title="userStore.user?.name"
                >
                  {{ userStore.user?.name }}
                </p>
                <label class="text-[10px] capitalize text-gray-500">
                  {{ userStore.user?.role }}</label
                >
              </div>
              <span class="[&>svg]:w-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                    clip-rule="evenodd"
                  />
                </svg>
              </span>
            </button>
            <ul
              class="dark:bg-surfa absolute left-0 right-0 top-12 z-[1000] float-left m-0 list-none rounded-lg border-none bg-white bg-clip-padding text-left text-base shadow-lg dark:bg-surface-dark overflow-hidden "
              :class="showModal ? 'block' : 'hidden'"
            >
              <li>
                <router-link
                  class="block w-full whitespace-nowrap bg-transparent px-4 py-2 text-sm font-normal text-neutral-700 hover:bg-[#40008A] hover:text-white"
                  to="/dashboard/profile"
                  data-twe-dropdown-item-ref
                  >My profile</router-link
                >
              </li>
              <li>
                <p
                  class="block w-full whitespace-nowrap bg-transparent px-4 py-2 text-sm font-normal text-neutral-700 hover:bg-[#40008A] hover:text-white cursor-pointer"
                  @click="logout"
                >
                  Logout
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-[#F2F1EC] grow relative p-4">
      <div class="flex gap-2 flex-wrap z-30 relative">
        <div v-for="(page, index) in pages" :key="index">
          <router-link
            :to="page.path"
            :class="
              route.path === page.path || (page.path === '/prospecting' && route.path.startsWith('/prospecting/'))
                ? 'bg-[#40008A] text-white'
                : 'font-medium text-gray-600'
            "
            class="cursor-pointer px-4 py-2 rounded-full text-[12px] block w-full z-30"
          >
            {{ page.name }}
          </router-link>
        </div>
      </div>

      <div class="mt-4 relative z-40">
        <slot></slot>
      </div>

      <img
        src="/images/authEllipse.png"
        alt="Example Image"
        class="authEllipse"
      />
      <img
        src="/images/authEllipseTop.png"
        alt="Example Image"
        class="authEllipseTop"
      />
      <img
        src="/images/dashboardLines.png"
        alt="Example Image"
        class="authEllipseTop"
      />
    </div>
  </div>
</template>

<style scoped>
.navLogo {
  object-fit: contain;
  height: 3.5rem;
}
.authEllipse {
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  z-index: 10;
  pointer-events: none;
}
.authEllipseTop {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  z-index: 10;
  pointer-events: none;
}
</style>